import {useState} from 'react';
import {getPublicCBLocations} from 'api/certification-bodies';
import {alertByError} from 'utils/alerts';

function useGetKeyLocations(cbId) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});

  async function getData(abId) {
    setIsLoading(true);
    try {
      const {data, meta} = await getPublicCBLocations(cbId, {
        accreditation_bodies_id: abId,
        limit: -1,
      });

      setData(data);
      setMeta(meta);
    } catch (e) {
      alertByError(e);
    } finally {
      setIsLoading(false);
    }
  }

  return {
    data,
    meta,
    isLoading,
    reload: getData,
  };
}

export default useGetKeyLocations;
